export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4625.a135e3bb.jpg";